import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery } from '@tanstack/react-query';
import { AlimTalkApi } from 'api';

/**
 * [AlimTalkTemplate] Query key 생성
 * --
 */
export const alimTalkQueryKeys = createQueryKeys('alim_talk', {
  getAlimTalkTemplate: (idx, params) => [idx, params],
  getAlimTalkTemplates: (params) => [params],
});

/**
 * [AlimTalkTemplate] 알림톡 템플릿 전체 조회
 * --
 */
export const useGetAlimTalkTemplates = (params, options) => {
  const data = useQuery({
    queryKey: alimTalkQueryKeys.getAlimTalkTemplates(params).queryKey,
    queryFn: () => AlimTalkApi.getAlimTalkTemplates(params),
    ...options,
  });
  return data;
};

/**
 * [AlimTalkTemplate] 알림톡 템플릿 상세 조회
 * --
 */
export const useGetAlimTalkTemplate = (idx, params, options) => {
  const data = useQuery({
    queryKey: alimTalkQueryKeys.getAlimTalkTemplate(idx, params).queryKey,
    queryFn: () => AlimTalkApi.getAlimTalkTemplate(idx, params),
    ...options,
  });

  return data;
};

/**
 * [AlimTalkTemplate] 알림톡 템플릿 생성
 * --
 */
export const useCreateAlimTalkTemplate = () => {
  const { mutateAsync: createAlimTalkTemplate, ...result } = useMutation({
    mutationFn: (variables) => AlimTalkApi.createAlimTalkTemplate(variables),
  });

  return { createAlimTalkTemplate, ...result };
};

/**
 * [AlimTalkTemplate] 알림톡 템플릿 수정
 * --
 */
export const useUpdateAlimTalkTemplate = () => {
  const { mutateAsync: updateAlimTalkTemplate, ...result } = useMutation({
    mutationFn: (variables) => AlimTalkApi.updateAlimTalkTemplate(variables),
  });

  return { updateAlimTalkTemplate, ...result };
};

/**
 * [AlimTalkTemplate] 알림톡 템플릿 삭제
 * --
 */
export const useDeleteAlimTalkTemplate = () => {
  const { mutateAsync: deleteAlimTalkTemplate, ...result } = useMutation({
    mutationFn: (variables) => AlimTalkApi.deleteAlimTalkTemplate(variables),
  });

  return { deleteAlimTalkTemplate, ...result };
};
